import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableHelper } from "common";
import { OfferBundleListQueryParams } from "./models/offer-bundle-query.model";

@Injectable({
  providedIn: "root",
})
export class OfferBundleFilterService {
  constructor(private router: Router) {}

  filter(applicationId: number, paginator?: MatPaginator, sort?: MatSort) {
    const query: OfferBundleListQueryParams = { skip: undefined };

    if (paginator) {
      query.limit = paginator.pageSize;
      query.skip = paginator.pageIndex * paginator.pageSize;
    }

    if (sort && sort.active) {
      query.sort = MatTableHelper.getSort(query.sort, sort);
    }

    this.router.navigate(["application", applicationId, "offer-bundles"], {
      replaceUrl: true,
      queryParams: query,
    });
  }
}
